import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

if (/\/%23\//i.test(window.location.href)) {
  window.location.href = window.location.href.replace('/%23/', '/#/');
}

ReactDOM.render(<App/>, document.getElementById('root'));